<div class="wrap">
  <div class="content">
    <div class="heading">
      <div class="title">Why choose Ketto?</div>
    </div>
    <div class="main-content">
      <div class="cards">
        <ngx-glide [arrowLeftTemplate]="(showCustomArrows && showArrows && arrowLeftTemplate) || null" 
        [arrowRightTemplate]="(showCustomArrows && showArrows && arrowRightTemplate) || null" [showArrows]="showArrows" [showBullets]="false" [gap]="10" type="slider" [breakpoints]="breakpoints" [perView]="3.2"
          [bound]="false" arrowLeftLabel="" arrowRightLabel="" [bound]="true">
          <div *ngFor="let item of cards; index as i" class="card-wrap">
            <div class="card _{{i+1}}">
              <div class="icon"><img loading="lazy" [attr.data-src]="item?.icon" alt="icon"></div>
              <div class="text" [innerHTML]="item?.title"></div>
            </div>
          </div>
        </ngx-glide>
        <ng-template #arrowLeftTemplate>
          <div class="custom-arrow custom-arrow-left">
            <mat-icon class="btn-clr">chevron_left</mat-icon>
          </div>
        </ng-template>
        <ng-template #arrowRightTemplate>
          <div class="custom-arrow custom-arrow-right">
            <mat-icon class="btn-clr">chevron_right</mat-icon>
          </div>
        </ng-template>
      </div>
    </div>
  </div>
</div>